import Skeleton from './src/skeleton';
export default Skeleton;
